import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { deleteSysOperationRecord as _deleteSysOperationRecord, getSysOperationRecordList, deleteSysOperationRecordByIds } from "@/api/sysOperationRecord"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
export default {
  name: "SysOperationRecord",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysOperationRecordList,
      dialogFormVisible: false,
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        ip: null,
        method: null,
        path: null,
        status: null,
        latency: null,
        agent: null,
        error_message: null,
        user_id: null
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDelete: function onDelete() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ids, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              _this.multipleSelection && _this.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 4;
              return deleteSysOperationRecordByIds({
                ids: ids
              });
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this.tableData.length == ids.length) {
                  _this.page--;
                }
                _this.deleteVisible = false;
                _this.getTableData();
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteSysOperationRecord: function deleteSysOperationRecord(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 3;
              return _deleteSysOperationRecord({
                ID: row.ID
              });
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this2.tableData.length == 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fmtBody: function fmtBody(value) {
      try {
        return JSON.parse(value);
      } catch (err) {
        return value;
      }
    }
  },
  created: function created() {
    this.getTableData();
  }
};